// emailReducer.js
import { SET_LOADING } from './emailActions';



const initialState = {
    // error: null,
    loading: false,
};
  
const emailReducer = (state = initialState, action) => {
    switch (action.type) {
        case SET_LOADING:
            return {
                ...state,
                loading: action.payload,
            };
        default:
            return state;
    }
};
  
export default emailReducer;